import {
  fetchClient
} from "./chunk-K342ITN7.mjs";
import {
  __async,
  __objRest
} from "./chunk-DFMI36TU.mjs";

// src/core/wbk/favorites/update.ts
import { Exception } from "@wbk/logger";
var updateUserInterests = (_a) => __async(void 0, null, function* () {
  var _b = _a, { lang } = _b, data = __objRest(_b, ["lang"]);
  try {
    const res = yield fetchClient({
      url: `/update-user-favorites?lang=${lang}`,
      options: {
        method: "POST",
        body: JSON.stringify(data)
      }
    });
    return res.user;
  } catch (error) {
    throw new Exception({
      error,
      name: "updateUserInterestsException"
    });
  }
});

export {
  updateUserInterests
};
//# sourceMappingURL=chunk-RFON2F2H.mjs.map